// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"12ec5637","334":"63ab6b40","763":"bea192bc"}[chunkId] + ".chunk.css";
};